import each from 'lodash/each'

type ApiAction = import('types/api').ApiPayloadAction
type ApiRequestConfig = import('types/api').ApiRequestConfig


export const create = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/graph/nodes',
    method: 'POST',
    data: {
      id: action.payload.id,
      content: action.payload.content,
      kind: action.payload.kind,
      readers: action.payload.readers,
      writers: action.payload.writers
    }
  }
}

export const edit = (action: ApiAction): ApiRequestConfig => {
  const req: ApiRequestConfig & { data: Record<string, unknown> } = {
    url: `/graph/nodes/${action.payload.id}`,
    method: 'PUT',
    data: {}
  }
  each(['content', 'kind'], (k: string) => {
    if (action.payload[k] != null) {
      req.data[k] = action.payload[k]
    }
  })
  return req
}

const deleteNode = (action: ApiAction): ApiRequestConfig => {
  return {
    url: `/graph/nodes/${action.payload.id}`,
    method: 'DELETE'
  }
}

export { deleteNode as delete }

export const deleteMulti = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/graph/nodes',
    method: 'DELETE',
    params: {
      ids: action.payload.ids
    }
  }
}
